import { SectionHeader } from "@/components/SectionHeader";
import hardwareRoom from "@/assets/hardware-room.webp";
import softwareRoom from "@/assets/software-room.webp";

const BLOCKS = [
  {
    eyebrow: "Somo hardware",
    title: "Guest room controls, designed to belong",
    body: "Somo hardware is designed to complement each property’s brand and environment, so the controls read as part of the room rather than equipment added to it.",
    tags: [
      "Central Intelligence",
      "Climate & Sensing",
      "Lighting",
      "Guest Room Controls",
    ],
    image: hardwareRoom,
    alt: "Guest room with Somo keypads and thermostat in place",
  },
  {
    eyebrow: "Somo software",
    title: "Somo Cloud Connect",
    body: "Configure, deploy, monitor, and manage Somo across rooms and properties from one place.",
    tags: ["Configurator", "Management Dashboard"],
    image: softwareRoom,
    alt: "Somo management dashboard over a guest room",
  },
];

export function HardwareSoftwareSection() {
  return (
    <section className="px-2 sm:px-4 py-20 md:px-6 md:py-16">
      <div className="mx-auto flex max-w-6xl flex-col gap-20">
        {BLOCKS.map((block) => (
          <div key={block.eyebrow} className="flex flex-col gap-12 md:gap-10">
            <SectionHeader
              variant="split"
              className="px-6 sm:px-4 md:px-0"
              eyebrow={block.eyebrow}
              title={block.title}
              body={block.body}
              aside={
                <ul className="flex flex-wrap gap-2 md:flex-col md:flex-nowrap md:items-end">
                  {block.tags.map((tag) => (
                    <li
                      key={tag}
                      className="flex h-8 items-center rounded-lg border border-current px-2.5 font-mono text-xs uppercase leading-loose tracking-caps text-secondary md:border-primary md:tracking-normal"
                    >
                      {tag}
                    </li>
                  ))}
                </ul>
              }
            />
            <img
              loading="lazy"
              decoding="async"
              src={block.image}
              alt={block.alt}
              data-tone="dark"
              className="h-96 w-full rounded-card object-cover md:h-auto md:aspect-[1130/540]"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
